"use client";

import { useMediaQuery, useTheme } from "@mui/material";

const useResponsiveFont = () => {
  const theme = useTheme();

  const isSmAndDown = useMediaQuery(theme.breakpoints.down("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));

  const getResponsiveRem = (baseRem: number) => {
    if (isSmAndDown) return `${(baseRem * 75) / 100}rem`;
    if (isMd) return `${(baseRem * 80) / 100}rem`;
    if (isLg) return `${(baseRem * 90) / 100}rem`;

    return `${baseRem}rem`;
  };

  return {
    getResponsiveRem,
  };
};

export default useResponsiveFont;
